import { createTheme } from "@mantine/core";

// Mantine-тема control plane.
//
// Пока сохраняем дефолты — «слот для будущих фич, а не финальный
// дизайн». Палитра, шрифты, радиусы прибудут вместе с дизайн-системой.
// Конкретный объект нужен сразу, иначе `MantineProvider` пришлось бы
// переподключать.
export const theme = createTheme({
  primaryColor: "blue",
});
